import SalesTypeForm from './SalesTypeForm.js'
import styles from './style.css'
import { connect } from 'react-redux'
import { submitFormCreate, submitFormUpdate, showNoGratuityModal, submitFormCreateAllOutlets } from 'actions/library/salesType'
import NoGratuityModal from './NoGratuityModal'
import {getFormValues} from 'redux-form'

class SalesTypeDetail extends React.Component {
  render () {
    return (
      <div className={`${styles.wrapper} sales-type-wrapper`}>
        <SalesTypeForm
          onSubmit={this._onSubmit}
        />
        <NoGratuityModal disableHideOnOuterModal />
      </div>
    )
  }

  _onSubmit = (values) => {
    const {dispatch, salesType, gratuity, businessId, outletForm, outlets, data} = this.props
    let initialSalesType = data.form.salesType.initial
    values.name = values.name.trim()
    values.outlet_id = outletForm.outletIds[0]
    if (values.active_gratuities.length === 0 && !values.id && gratuity.results.length !== 0) {
      dispatch(showNoGratuityModal(values.action))
    } else {
      if (values.action === 'save') {
        delete values.action
        if (values.id) {
          dispatch(submitFormUpdate(values.id, businessId, values, salesType, initialSalesType, gratuity))
        } else {
          dispatch(submitFormCreate(values, businessId, salesType))
        }
      } else {
        delete values.action
        dispatch(submitFormCreateAllOutlets(values, businessId, salesType, outlets))
      }
    }
  }
}

function mapDispatchToProps (dispatch) {
  return {dispatch}
}

function mapStateToProps (state) {
  const {salesType, gratuity, outlets} = state.library.salesType
  let businessId = state.moka.user.business.id
  let outletForm = getFormValues('search')(state)
  return {
    salesType,
    gratuity,
    businessId,
    outletForm,
    outlets,
    data: {
      form: state.form
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SalesTypeDetail)



// WEBPACK FOOTER //
// ./app/pages/Library/SalesType/SalesTypeDetail/SalesTypeDetail.js